var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackarrowBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.993 6C15.3789 6 15.8035 6.14815 16.1123 6.44444C16.6912 7.03704 16.6912 7.96296 16.0737 8.55556L9.66667 14.963L16.5368 21.4444C17.1544 22.037 17.1544 22.963 16.5368 23.5556C15.9193 24.1482 14.9544 24.1482 14.3368 23.5556L6.54035 16.1852C6.19299 15.8519 6 15.4074 6 14.9259C6 14.4444 6.19299 14 6.54035 13.6667L13.8737 6.40741C14.2211 6.14815 14.607 6 14.993 6Z",
    fill: "#434B58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87474 13.0488L22.5804 13C23.3612 13 24 13.878 24 14.9512C24 16.0244 23.3612 16.9024 22.5804 16.9024L8.70355 17C8.24217 17 7.81628 16.7561 7.49687 16.3171C7.17745 15.8781 7 15.2439 7 14.6585L9.87474 13.0488Z",
    fill: "#434B58"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackarrowBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/backarrow_black.255d8f925b8d0323d99dddfda97f4067.svg";